import user from './user';
const state = {
	StoreAgentInfo: JSON.parse(localStorage.getItem('tel-service-agent-info')), // ~ agent电话相关信息
	StoreSingInCategory: localStorage.getItem('tel-service-sign-in-category'), // ~ 签入类型
	StoreIsSignIn: JSON.parse(localStorage.getItem('tel-service-is-sign-in')), // ~ 是否签入
	StoreIsIdle: JSON.parse(localStorage.getItem('tel-service-is-idle')), // ~ 是否置闲
	StoreIsBusy: JSON.parse(localStorage.getItem('tel-service-is-busy')), // ~ 是否置忙
	StoreIsBusyReason: localStorage.getItem('tel-service-is-busy-reason'), // ~ 置忙原因
	StoreIsCall: JSON.parse(localStorage.getItem('tel-service-is-call')), // ~ 是否来电
	StoreIsCallCurrentInfo: JSON.parse(localStorage.getItem('tel-service-is-call-current-info')), // ~ 当前来电信息
	StoreIsAnswer: JSON.parse(localStorage.getItem('tel-service-is-answer')), // ~ 是否接听
	StoreIsKeep: JSON.parse(localStorage.getItem('tel-service-is-keep')), // ~ 是否保持
	StoreIsBusyReasonList: JSON.parse(localStorage.getItem('tel-service-is-busy-reason-list')) || [],
	StoreIsMonitor: localStorage.getItem('tel-service-is-monitor'), // ~ 是否正在监控
	StoreCallTime: '00:00:00',
	StoreSoftPhoneInMsg: [],
	StoreTelRoles: [],
	StoreTuId: '',
	StoreCallout:false, // 是否主动拨打外呼
	StoreAuxList: []
};

const mutations = {
	SET_TU_ID: (state, StoreTuId) => {
		state.StoreTuId = StoreTuId;
	},
	SET_CALLOUT: (state, StoreCallout) => {
		state.StoreCallout = StoreCallout;
	},
	SET_RESET_JS_SIP_SETTING: (state) => {
		// mutations.SET_IS_BUSY(state, {StoreIsBusy: false, StoreIsBusyReason: ''});
		// mutations.SET_IS_IDLE(state, false);
		mutations.SET_IS_CALL(state, false);
		mutations.SET_IS_ANSWER(state, false);
		mutations.SET_IS_KEEP(state, false);
		// Vue.prototype.$api.apiPostCallSetBusy({agentName: user.state?.userInfo?.agentCode, auxCode: 0});
	},
	SET_AGENT_INFO: (state, StoreAgentInfo) => {
		localStorage.setItem('tel-service-agent-info', JSON.stringify(StoreAgentInfo));
		state.StoreAgentInfo = StoreAgentInfo;
	},
	SET_IS_SIGN_IN: (state, data) => {
		localStorage.setItem('tel-service-sign-in-category', data?.StoreSingInCategory);
		localStorage.setItem('tel-service-is-sign-in', data?.StoreIsSignIn);
		state.StoreSingInCategory = data?.StoreSingInCategory;
		state.StoreIsSignIn = data?.StoreIsSignIn;
	},
	SET_IS_IDLE: (state, StoreIsIdle) => {
		localStorage.setItem('tel-service-is-idle', StoreIsIdle);
		state.StoreIsIdle = StoreIsIdle;
	},
	SET_IS_BUSY: (state, data) => {
		state.StoreIsBusy = data?.StoreIsBusy;
		state.StoreIsBusyReason = data?.StoreIsBusyReason;
		localStorage.setItem('tel-service-is-busy', data?.StoreIsBusy);
		localStorage.setItem('tel-service-is-busy-reason', data?.StoreIsBusyReason);
	},
	SET_IS_BUSY_REASON: (state, StoreIsBusyReason) => {
		state.StoreIsBusyReason =StoreIsBusyReason;
		localStorage.setItem('tel-service-is-busy-reason', StoreIsBusyReason);
	},
	SET_IS_CALL: (state, StoreIsCall) => {
		localStorage.setItem('tel-service-is-call', StoreIsCall);
		state.StoreIsCall = StoreIsCall;
	},
	SET_IS_CALL_CURRENT_INFO: (state, StoreIsCallCurrentInfo) => {
		localStorage.setItem('tel-service-is-call-current-info', JSON.stringify(StoreIsCallCurrentInfo));
		state.StoreIsCallCurrentInfo = StoreIsCallCurrentInfo;
	},
	SET_IS_ANSWER: (state, StoreIsAnswer) => {
		localStorage.setItem('tel-service-is-answer', StoreIsAnswer);
		state.StoreIsAnswer = StoreIsAnswer;
	},
	SET_IS_KEEP: (state, StoreIsKeep) => {
		localStorage.setItem('tel-service-is-keep', StoreIsKeep);
		state.StoreIsKeep = StoreIsKeep;
	},
	SET_CALL_TIME: (state, StoreCallTime) => {
		state.StoreCallTime = StoreCallTime;
	},
	SET_IS_MONITOR: (state, StoreIsMonitor) => {
		localStorage.setItem('tel-service-is-monitor', StoreIsMonitor);
		state.StoreIsMonitor = StoreIsMonitor;
	},
	SET_SOFT_IS_BUSY_REASON_LIST: (state, StoreIsBusyReasonList) => {
		localStorage.setItem('tel-service-is-busy-reason-list', JSON.stringify(StoreIsBusyReasonList));
		state.StoreIsBusyReasonList = StoreIsBusyReasonList;
	},
	SET_SOFT_PHONE_IN_MSG: (state, data) => {
		const msg = `${dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')} - 操作人：${user?.state?.userInfo?.account} - 操作了： ${data.msg} ${data?.data ? ' - 详细信息： ' + JSON.stringify(data?.data) : ''}`;
		console.log(`%c${msg}`, 'color: #E6A23C');
		state.StoreSoftPhoneInMsg.unshift(msg);
		// Vue.prototype.$api.apiPostAddTelLog({msg: msg});
		Vue.prototype.$$log({
			category: "Behavior",
			sourceType: "Tel",
			message: data,
		});
	},
	SET_TEL_ROLES: (state, StoreTelRoles) => {
		state.StoreTelRoles = [];
		for(const item of StoreTelRoles) {
			state.StoreTelRoles.push(item.viewUrl);
		}
	},
	SET_SOFT_PHONE_AUX_LIST: (state, StoreAuxList) => {
		state.StoreAuxList = StoreAuxList;
	}
};

const actions = {
	StoreTelRolesAction({ commit }, data) {
		commit('SET_TEL_ROLES', data);
	},
	StoreSoftPhoneInit({ commit, rootGetters }) {
		commit('SET_AGENT_INFO', {});
		commit('SET_IS_SIGN_IN', {
			StoreIsSignIn: false,
			StoreSingInCategory: ''
		});
		commit('SET_IS_IDLE', false);
		commit('SET_IS_BUSY', {
			StoreIsBusy: false,
			StoreIsBusyReason: ''
		});
		commit('SET_IS_IDLE', false);
		commit('SET_IS_CALL', false);
		commit('SET_IS_CALL_CURRENT_INFO', {});
		commit('SET_IS_ANSWER', false);
		commit('SET_IS_KEEP', false);
		commit('SET_CALL_TIME', false);
		commit('SET_IS_MONITOR', false);
		commit('SET_SOFT_IS_BUSY_REASON_LIST', []);
		commit('SET_SOFT_PHONE_IN_MSG', []);
		commit('SET_TEL_ROLES', []);
		Vue.prototype.$api.apiPostCallSignOut({agentName: rootGetters.userInfo?.agentCode});
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}